import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Chart from "react-apexcharts";
import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import ReactECharts from "echarts-for-react";

const addValues = (arrays) => {
    if (arrays.length === 0)
        return null;

    const result = Array(arrays[0].length).fill(0);

    arrays.forEach(array => {
        array.forEach((value, index) => {
            result[index] += value;
        });
    });

    return result;

}

function RealizedConsumptionChart(props) {

    const { data, timeAggType } = props;

    const { t } = useTranslation();

    let timestamps = data.timestamps?.map(
        (item) => timeAggType !== "q"? item : (item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01"))
    ) ?? [];

    let series = [];

    const solarData = addValues(data.data?.filter((t)=>t.metadata.key === "SOLAR_PRODUCTION").map((t)=>t.values) ?? [])
    const cogenData = addValues(data.data?.filter((t)=>t.metadata.key === "COGENERATION").map((t)=>t.values) ?? [])
    const powerMeterData = addValues(data.data?.filter((t)=>t.metadata.key === "POWER_METER").map((t)=>t.values) ?? [])

    const totalData = powerMeterData?.map((elem, i) => elem + (solarData ? solarData[i] : 0.0));
    const gridData = powerMeterData?.map((elem, i) => elem - (cogenData ? cogenData[i] : 0.0));
    
    if (totalData) {
        series.push({
            name: t("Total"),
            data: totalData,
            type:'line',
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })
    }
    
    if (solarData) {
        series.push({
            name: t("Solar"),
            data: solarData,
            type:'line',
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })
    }

    if (gridData) {
        series.push({
            name: t("Grid"),
            data: gridData,
            type:'line',
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })
    }

    if (cogenData) {
        series.push({
            name: t("Co-generation"),
            data: cogenData,
            type:'line',
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })
    }

    let title = t("Realized consumption and generation") + " [kW]";
        

    
    let options = {
            tooltip: {
                trigger: "axis",
                valueFormatter: (value) =>
                    typeof value == "number" ? value.toLocaleString(navigator.language,{
                        minimumFractionDigits:2,
                        maximumFractionDigits:2
                    }) : value,
            },
            grid: {
                top: '4%',
                containLabel: true,
                left: '4%',
                right: '5%',
                bottom: 25
                
            },
            legend: {
                show: true,
                bottom: 0, 
                left: "center",
                symbol: 'none'
            },
            xAxis: {
                type: 'category',
                data: timestamps,
                silent: false,
            },
            yAxis: {
                splitArea: {
                    show: false,
                },
            },
            textStyle: {
                fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
            },
            series: series,
        };

    return (
        <Stack>
            <Typography paddingTop={'25px'} align="center" component="h2" variant="h6" color="primary" gutterBottom>{title}</Typography>
            <ReactECharts option={options}/> 
            
        </Stack>
        
    )

};




export default RealizedConsumptionChart;